import { reactive } from '@vue/composition-api';

import { PaneState } from '@/models/externalReports/standard/standardMap';
import {
  LIST_HARD_MAX_HEIGHT_PX,
  PANE_SIDE_HARD_MAX_WIDTH_PX,
} from '@/components/ExternalReports/Standard/consts';

interface UsePaneControlParams {
  paneStyleLimits?: {
    listMinHeightRate: number;
    listMaxHeightRate: number;
  };
}
interface UsePaneControlResult {
  paneState: PaneState;
  onChangeShowCarIcons: () => void;
  onChangePhotoTypeVisibility: (photoType: string, isVisible: boolean) => void;
}

export default function usePaneControl(params: UsePaneControlParams): UsePaneControlResult {
  const paneState = reactive<PaneState>({
    showCarIcons: true,
    photoTypeVisibility: {},
    paneStyleLimits: {
      listMinHeightRate: params.paneStyleLimits?.listMinHeightRate || 0,
      listMaxHeightRate: params.paneStyleLimits?.listMaxHeightRate || 0,
    },
    paneStyle: {
      paneSideMinWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
      paneSideMaxWidth: PANE_SIDE_HARD_MAX_WIDTH_PX,
      listMinHeight: LIST_HARD_MAX_HEIGHT_PX,
      listMaxHeight: LIST_HARD_MAX_HEIGHT_PX,
    },
  });

  const onChangeShowCarIcons = () => {
    paneState.showCarIcons = !paneState.showCarIcons;
  };

  const onChangePhotoTypeVisibility = (photoType: string, isVisible: boolean) => {
    paneState.photoTypeVisibility[photoType] = isVisible;
  };

  return {
    paneState,
    onChangeShowCarIcons,
    onChangePhotoTypeVisibility,
  };
}
